export class WorkerExposure {
  name: string;
  color: string;
  workers: number;
  percentageOfWorkers: number;
  percentageOfWorkersAbs: number;
  change: number;
  changePercent: number;
  changePercentAbs: number;
}
export class ExposureBySEGs {
  segId: string;
  segName: string;
  severity?: number;
  taskGroupId?: string;
  riskCategory: string;
  previousColor: string;
  color: string;
  workers: number;
  change?: number;
  isChangeAlert: boolean;
  numberOfSamples: number;
  isGsdAlert: boolean;
}

export class ExposureForSegDTO{
  segId: string;
  segName: string;
  orgLevelId: string;
  orgLevelName: string;
  workers: number;
  riskCategory: string;
}

export class ExposureForSegByOrgLevel {
  isChangeAlert: boolean;
  isGsdAlert: boolean;
  numberOfSamples: number;
  orgLevelId: string;
  orgLevelName: string;
  workers: number;
  riskCategory: string;
  severity?: number;
  color?: string;
  change?: number;
}

export class ExposureByTask {
  massContribution: number;
  massContributionPercent: number;
  massContributionPercentAbs: number;
  taskGroupName: string;
  taskId: string;
  taskGroupId?: string;
  taskName: string;
  timeOnShift: number;
  timeOnShiftPercent: number;
  timeOnShiftPercentAbs: number;
}
export class ExposureByTaskGroup {
  taskGroupId!: string;
  taskGroupName: string;
  massContribution: number;
  massContributionPercent: number;
  massContributionPercentAbs: number;
  change?: number;
}
export interface ExposureByTaskGroupVm extends ExposureByTaskGroup {
  changeAbsPercent: string;
  changePercent: number;
}
export class ExposureByLocationGroup {
  locationGroupName: string;
  massContribution: number;
  massContributionPercent: number;
  massContributionPercentAbs: number;
  change?: number;
}
export class ExposureTaskDistribution {
  massContribution: number;
  massContributionPercent: number;
  massContributionPercentAbs: number;
  orgLevelName: string;
  orgLevelId: string;
}
export class ExposureTaskSample {
  createdDate: number;
  orgLevelId: string;
  orgLevelName: string;
  result: number;
  resultUnit: number;
  sampleNumber: string;
  segId: string;
  segName: string;
  sensorAssignmentId: string;
  taskContribution: number;
  taskContributionPercent: number;
  taskContributionPercentAbs: number;
  timeOnShift: number;
  timeOnShiftMins?: number;
}

export class SegAssignRequest {
  segIds: string[];
  taskGroupId: string;
}